/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */

import PaletteIconQuestion from '@telus-uds/palette-allium/build/rn/icons/Question'
const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    { if: { inverse: true }, tokens: { iconColor: '#ffffff' } },
    { if: { hover: true }, tokens: { iconScale: 1.25 } },
    { if: { pressed: true }, tokens: { iconColor: '#676e73' } },
    {
      if: { inverse: true, pressed: true },
      tokens: { iconColor: '#b2b9bf' }
    },
    { if: { focus: true }, tokens: { outerBorderColor: '#676e73' } },
    {
      if: { focus: true, inverse: true },
      tokens: { outerBorderColor: '#b2b9bf' }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 32,
    icon: PaletteIconQuestion,
    iconColor: '#2c2e30',
    iconScale: 1,
    iconSize: 16,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 4,
    outerBorderWidth: 1,
    width: 16
  }
}
export default theme
